import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { browserHistory } from 'react-router'
import Loadable from 'react-loading-overlay'

import AccessoryView from './accessoryview'
import BhphView from './bhphview'
import FleetView from './fleetview'

@observer(['agreements', 'globals', 'invoices', 'quickbooks'])
export default class InvoiceView extends Component {

    constructor(props) {
        super(props)

        this.state = {
            loadableState: true
        }
    }

    redirectProcessPaymentPage(invoiceId, signature, callback) {

        if (signature.length == 0) {
            alert('You must write your full name to agree to the terms and conditions before continuing!')
        }
        else {
            //Store signature
            let data = {
                invoiceId: invoiceId,
                signature: signature
            }

            this.props.invoices.saveInvoiceSignature(data, (res) => {
                if (!res || !res.saveQuoteSignature) {
                    alert('We were unable to save your signature. Please try again or contact GPS Leaders.')
                    return
                }
                //Send user to payment process page
                browserHistory.push('/processpayment/' + this.props.token)
            })
        }

        if (callback) {
            return callback
        }
    }

    setLoadableState(state) {
        this.setState({
        loadableState: state
        })
    }

    render() {
        let invoiceTypeView = ''
        if (this.props.invoices.invoiceViewDetails.quoteType) {
            switch (this.props.invoices.invoiceViewDetails.quoteType) {
                case 'accessory':
                  invoiceTypeView = <AccessoryView token={this.props.token} setLoadableState={ this.setLoadableState.bind(this) } redirectProcessPaymentPage={this.redirectProcessPaymentPage.bind(this)} />
                break
                case 'bhph':
                  invoiceTypeView = <BhphView token={this.props.token} setLoadableState={ this.setLoadableState.bind(this) } redirectProcessPaymentPage={this.redirectProcessPaymentPage.bind(this)} />
                break
                case 'fleet':
                  invoiceTypeView = <FleetView token={this.props.token} setLoadableState={ this.setLoadableState.bind(this) } redirectProcessPaymentPage={this.redirectProcessPaymentPage.bind(this)} />
                break
                /*
                default:
                    
                break
                */
            }
        }

        return (
            <div>
                <Loadable active={ this.state.loadableState } spinner text='Processing your request...'>
                    { invoiceTypeView }
                </Loadable>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/invoices/invoiceview.js